import { Injectable } from '@angular/core';
import { SessionCookies } from '@enums';
import { CookieService } from 'ngx-cookie-service';

@Injectable({ providedIn: 'root' })
export class FeatureFlagsService {
  constructor(private cookieService: CookieService) {}

  hidePrices(): boolean {
    return this.cookieService.get(SessionCookies.hidePrices) === 'true';
  }
}
